import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { type LoadingProps } from './types';

export const Loading: React.FunctionComponent<LoadingProps> = (
  props: LoadingProps,
) => {
  const { openLoading = true, setOpenLoading, loadingText } = props;

  const handleClose = (): void => {
    if (setOpenLoading !== undefined) {
      setOpenLoading(false);
    }
  };

  return (
    <div>
      <Backdrop
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        }}
        // remark:
        // theme.zIndex.drawer is usually set to 1200.
        // theme.zIndex.modal is usually set to 1300.
        sx={{ color: '#fff', zIndex: 2000 }}
        open={openLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
        {loadingText}
      </Backdrop>
    </div>
  );
};
